import { z } from "zod";
import { ROLES } from "./roles.js";
import { PLATFORM_ROLES, TENANT_ROLES } from "./organizations.js";
import { normalizeTotpCode, toAsciiDigits } from "./digits.js";
export const loginSchema = z.object({
    email: z.string().email().max(254),
    password: z.string().min(1).max(128),
});
export const mfaEnrollConfirmSchema = z.object({
    enrollmentToken: z.string().min(1),
    code: z
        .string()
        .transform((v) => normalizeTotpCode(v))
        .pipe(z.string().regex(/^\d{6}$/, "TOTP code must be 6 digits")),
});
export const mfaVerifySchema = z.object({
    challengeToken: z.string().min(1),
    code: z
        .string()
        .min(1)
        .max(16)
        .transform((v) => toAsciiDigits(v).trim()),
});
export const adminMembershipSummarySchema = z.object({
    organizationId: z.string(),
    organizationCode: z.string(),
    organizationDisplayName: z.string(),
    organizationStatus: z.enum(["draft", "active", "suspended", "archived"]),
    role: z.enum(TENANT_ROLES),
    status: z.enum(["invited", "active", "suspended", "removed"]),
});
export const selectableOrganizationSchema = z.object({
    organizationId: z.string(),
    code: z.string(),
    displayName: z.string(),
    status: z.enum(["draft", "active", "suspended", "archived"]),
    source: z.enum(["membership", "platform"]),
    membershipRole: z.enum(TENANT_ROLES).nullable().optional(),
});
export const selectOrganizationSchema = z.object({
    organizationId: z.string().min(1).max(64),
});
export const adminMeSchema = z.object({
    id: z.string(),
    email: z.string().email(),
    displayName: z.string(),
    role: z.enum(ROLES),
    mfaEnabled: z.boolean(),
    platformRole: z.enum(PLATFORM_ROLES).nullable().optional(),
    selectedOrganizationId: z.string().nullable().optional(),
    organizationStatus: z.enum(["draft", "active", "suspended", "archived"]).nullable().optional(),
    membershipRole: z.enum(TENANT_ROLES).nullable().optional(),
    memberships: z.array(adminMembershipSummarySchema).optional(),
    selectableOrganizations: z.array(selectableOrganizationSchema).optional(),
});
//# sourceMappingURL=auth.js.map